import { BaseSelectField } from "../components/BaseSelectField/BaseSelectField";
import { useEffect, useState } from "react";
import GetFetch from "../hooks/GetFetch";
import DataSource from "devextreme/data/data_source";
import { LoadingIndicatorCircle } from "../components/Loading";
import SingleRegionSelectField from "../components/SingleRegionSelectField/SingleRegionSelectField";


const CustomerBuildingSelect = ({ editing, value, valueSetter }) => {
    const [buildingList, setBuildingList] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedRegion, setSelectedRegion] = useState(null);
    const [error, setError] = useState(null);
    useEffect(() => {
        fetchBuildings();
    }, [selectedRegion]);

    const fetchBuildings = async () => {
        if (selectedRegion) {
            setIsLoading(true);
            const { Success, Message, Errors } = await GetFetch(`/v1/Building/Region/` + selectedRegion);
            if (Success) {
                setBuildingList(Message);
                // console.log("buildings message", Message)
            }
            else {
                setError(Errors[0].Message);
            }
            setIsLoading(false);
        }
    }
    const optionUpdatedByUser = (e) => {
        // console.log(e)
        const sel = e.selectedItem;
        valueSetter(sel)
    };
    const regionUpdatedByUser = (e) => {
        // console.log(e)
        setBuildingList(null);
        const sel = e.selectedItem;
        setSelectedRegion(sel)
    };
    const buildingDataSource = new DataSource({
        store: {
            type: 'array',
            data: buildingList,
            key: 'BuildingId'
        },
        paginate: true,
        pageSize: 10
    });
    return (
        <div style={{ display: 'flex' }}>
            <SingleRegionSelectField
                label="Select a Region"
                optionUpdatedByUser={regionUpdatedByUser}
                isVisible={true}
                value={selectedRegion}
                readOnly={!editing}
                enableSearch={true}
            />
            <BaseSelectField
                inputAttribute={{ id: "customer_building_select_dropdown" }}
                label="Select a Building"
                data={buildingDataSource}
                enableSearch={true}
                optionUpdatedByUser={optionUpdatedByUser}
                value={value}
                optionsLabel={"SequenceNumber"}
                requireValidation={false}
                isVisible={true}
                readOnly={selectedRegion === null || isLoading || !editing}
            />
            {
                isLoading &&
                <span className="inline__span--wrapper">
                    <LoadingIndicatorCircle message={`Loading buildings from region ${selectedRegion}...`} />
                </span>
            }
        </div>
    )
}
export default CustomerBuildingSelect;